import { Button } from "antd";
import { FC } from "react";
import { FaCheck } from "react-icons/fa6";
import { StarPlanSvg } from "../../../assets/SVGs/SVGs";

interface PlanProps {
  recommended?: boolean;
  SalonPlanId?: number;
  features: any;
  taxFeatures: any;
  data?: any;
  currentPlan?: any;
}

const Plan: FC<PlanProps> = ({
  recommended,
  features,
  taxFeatures,
  data,
  SalonPlanId,
  currentPlan,
}) => {
  console.log(currentPlan);

  return (
    <div
      id="pricing-plans"
      className={
        "p-6 flex flex-col h-fit gap-4 justify-center items-center rounded-lg shadow min-w-fit " +
        (data?.id === currentPlan ? " bg-white " : " bg-[#F0F5FF]")
      }
    >
      <div className="space-y-4">
        <h3
          className={
            "  text-center text-[18px] " +
            (data?.id === currentPlan
              ? " text-color-primary font-semibold"
              : "font-medium text-[#020418]")
          }
        >
          {data?.title}
        </h3>
        {data?.name !== "Free" ? (
          <div className="flex items-center justify-center gap-1 text-color-primary">
            <p className="text-2xl font-bold text-color-primary">
              {data?.price}
            </p>
            <p className="font-normal text-[10px] flex items-center">
              SR/month
            </p>
          </div>
        ) : (
          <div className="flex items-center justify-center gap-2 text-2xl font-medium text-color-primary">
            <p>{StarPlanSvg}</p>
            {data?.name}
          </div>
        )}
      </div>
      {data?.id === currentPlan ? (
        <div className="relative flex justify-center w-full h-10">
          <div className=" bg-color-primary h-[1px] w-full absolute  top-1/2  "></div>

          <p className="z-10 mx-auto inline-block bg-[#7FE1C2] text-color-primary text-large font-bold p-2 px-4 rounded-lg">
            Current plan
          </p>
        </div>
      ) : (
        <div className=" bg-[#CFDEFC] h-[1px] w-full "></div>
      )}
      <div>
        {
          <ul className="flex flex-col gap-2 text-sm">
            {features?.map((feature: any, i: any) => (
              <li key={i} className="flex items-center gap-2">
                <FaCheck className="flex items-center text-[#479821]" />
                <span className="">{feature?.value}</span>
                <span>{feature?.name}</span>
              </li>
            ))}
          </ul>
        }
      </div>
      <div className="w-full">
        {data?.id === currentPlan || (
          <Button
            type={"primary"}
            className={
              "w-full rounded-lg font-bold bg-color-primary hover:bg-color-primary hover:text-white text-white"
            }
          >
            Upgrade
          </Button>
        )}
      </div>
      <div>
        <div className="flex flex-col gap-2 text-xs">
          {taxFeatures?.map((feature: any, i: any) => (
            <div key={i} className="flex gap-2">
              <span className="font-semibold text-color-primary">{"+"}</span>
              <span className="">{feature?.value}%</span>
              <span className="text-[#75757E]">{feature?.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Plan;
